import { ROUTES } from '~/constants/pageRoutes';

const analyticEvents = {
    startnow_signup_begin: {
        GA: 'startnow_signup_begin'
    },
    quickdiag_start_test: {
        GA: 'quickdiag_start_test'
    },
    quickdiag_instruction_begin: {
        GA: 'quickdiag_instruction_begin'
    },
    quickdiag_instruction_cancel: {
        GA: 'quickdiag_instruction_cancel'
    },
    quickdiag_exit_test: {
        // NF
        GA: 'quickdiag_exit_test'
    },
    quickdiag_finish_test: {
        GA: 'quickdiag_finish_test'
    },
    signup_otp_requested: {
        GA: 'signup_otp_requested'
    },
    signup_otp_verified: {
        GA: 'signup_otp_verified'
    },
    login_otp_requested: {
        GA: 'login_otp_requested'
    },
    login_otp_verified: {
        GA: 'login_otp_verified'
    },
    google_signin_success: {
        GA: 'google_signin_success'
    },
    signup_success: {
        GA: 'signup_success',
        WE: 'prep_signup_success'
    },
    signup_completed: {
        GA: 'signup_completed',
        WE: 'prep_signup_completed'
    },
    login_success: {
        GA: 'login_success',
        WE: 'prep_login_success'
    },
    loggedin_profile_completed: {
        GA: 'loggedin_profile_completed',
        WE: 'prep_loggedin_profile_completed'
    },
    signup_acqmodal_success: {
        GA: 'signup_acqmodal_success',
        WE: 'prep_signup_acqmodal_success'
    },
    signup_acqmodal_dismiss: {
        GA: 'signup_acqmodal_dismiss',
        WE: 'prep_signup_acqmodal_dismiss'
    },
    // Dashboard events
    prep_quickdiag_dashboard_setup: {
        GA: 'quickdiag_dashboard_setup',
        WE: 'prep_quickdiag_dashboard_setup'
    },
    prep_fulldiag_dashboard_setup: {
        GA: 'fulldiag_dashboard_setup',
        WE: 'prep_fulldiag_dashboard_setup'
    },
    // Test events
    prep_fulldiag_start_test: {
        GA: 'fulldiag_start_test',
        WE: 'prep_fulldiag_start_test'
    },
    prep_fulldiag_instruction_begin: {
        GA: 'fulldiag_instruction_begin',
        WE: 'prep_fulldiag_instruction_begin'
    },
    prep_fulldiag_instruction_cancel: {
        GA: 'fulldiag_instruction_cancel',
        WE: 'prep_fulldiag_instruction_cancel'
    },
    prep_fulldiag_exit_test: {
        GA: 'fulldiag_exit_test',
        WE: 'prep_fulldiag_exit_test'
    },
    prep_fulldiag_finish_test: {
        GA: 'fulldiag_finish_test',
        WE: 'prep_fulldiag_finish_test'
    },
    prep_topic_start_test: {
        GA: 'topic_start_test',
        WE: 'prep_topic_start_test'
    },
    prep_topic_instruction_begin: {
        GA: 'topic_instruction_begin',
        WE: 'prep_topic_instruction_begin'
    },
    prep_topic_instruction_cancel: {
        GA: 'topic_instruction_cancel',
        WE: 'prep_topic_instruction_cancel'
    },
    prep_topic_exit_test: {
        GA: 'topic_exit_test',
        WE: 'prep_topic_exit_test'
    },
    prep_topic_finish_test: {
        GA: 'topic_finish_test',
        WE: 'prep_topic_finish_test'
    },
    prep_mini_start_test: {
        GA: 'mini_start_test',
        WE: 'prep_mini_start_test'
    },
    prep_mini_instruction_begin: {
        GA: 'mini_instruction_begin',
        WE: 'prep_mini_instruction_begin'
    },
    prep_mini_instruction_cancel: {
        GA: 'mini_instruction_cancel',
        WE: 'prep_mini_instruction_cancel'
    },
    prep_mini_exit_test: {
        GA: 'mini_exit_test',
        WE: 'prep_mini_exit_test'
    },
    prep_mini_finish_test: {
        GA: 'mini_finish_test',
        WE: 'prep_mini_finish_test'
    },
    prep_mini_continue_next: {
        GA: 'mini_continue_next',
        WE: 'prep_mini_continue_next'
    },
    prep_mini_pause_save: {
        GA: 'mini_pause_save',
        WE: 'prep_mini_pause_save'
    },
    prep_mock_start_test: {
        GA: 'mock_start_test',
        WE: 'prep_mock_start_test'
    },
    prep_mock_instruction_begin: {
        GA: 'mock_instruction_begin',
        WE: 'prep_mock_instruction_begin'
    },
    prep_mock_instruction_cancel: {
        GA: 'mock_instruction_cancel',
        WE: 'prep_mock_instruction_cancel'
    },
    prep_mock_exit_test: {
        GA: 'mock_exit_test',
        WE: 'prep_mock_exit_test'
    },
    prep_mock_finish_test: {
        GA: 'mock_finish_test',
        WE: 'prep_mock_finish_test'
    },
    prep_mock_continue_next: {
        GA: 'mock_continue_next',
        WE: 'prep_mock_continue_next'
    },
    prep_mock_pause_save: {
        GA: 'mock_pause_save',
        WE: 'prep_mock_pause_save'
    },
    // Planer events
    prep_planner_click: {
        GA: 'planner_click',
        WE: 'prep_planner_click'
    },
    prep_planner_build_plan: {
        GA: 'planner_build_plan',
        WE: 'prep_planner_build_plan'
    },
    prep_upgrade_to_plus: {
        GA: 'upgrade_to_plus',
        WE: 'prep_upgrade_to_plus'
    },

    // Payment events
    prepplus_1m_payment_proceed: {
        GA: 'prepplus_1m_payment_proceed',
        WE: 'prepplus_1m_payment_proceed'
    },
    prepplus_1m_payment_completed: {
        GA: 'prepplus_1m_payment_completed',
        WE: 'prepplus_1m_payment_completed'
    },
    prepplus_3m_payment_proceed: {
        GA: 'prepplus_3m_payment_proceed',
        WE: 'prepplus_3m_payment_proceed'
    },
    prepplus_3m_payment_completed: {
        GA: 'prepplus_3m_payment_completed',
        WE: 'prepplus_3m_payment_completed'
    },
    prepplus_6m_payment_proceed: {
        GA: 'prepplus_6m_payment_proceed',
        WE: 'prepplus_6m_payment_proceed'
    },
    prepplus_6m_payment_completed: {
        GA: 'prepplus_6m_payment_completed',
        WE: 'prepplus_6m_payment_completed'
    },
    prepplus_yocket_pro_payment_proceed: {
        GA: 'prepplus_yocket_pro_payment_proceed',
        WE: 'prepplus_yocket_pro_payment_proceed'
    },
    prepplus_yocket_pro_payment_completed: {
        GA: 'prepplus_yocket_pro_payment_completed',
        WE: 'prepplus_yocket_pro_payment_completed'
    },
    prepplus_liveclass_payment_proceed: {
        GA: 'prepplus_liveclass_payment_proceed',
        WE: 'prepplus_liveclass_payment_proceed'
    },
    prepplus_liveclass_payment_completed: {
        GA: 'prepplus_liveclass_payment_completed',
        WE: 'prepplus_liveclass_payment_completed'
    },
    prepplus_ondemand_payment_proceed: {
        GA: 'prepplus_ondemand_payment_proceed',
        WE: 'prepplus_ondemand_payment_proceed'
    },
    prepplus_ondemand_payment_completed: {
        GA: 'prepplus_ondemand_payment_completed',
        WE: 'prepplus_ondemand_payment_completed'
    },
    prep_subscribed_user: {
        WE: 'prep_subscribed_user'
    },

    prep_refer_clicked: {
        GA: 'refer_clicked',
        WE: 'prep_refer_clicked'
    },
    prep_referal_url_copied: {
        GA: 'referal_url_copied',
        WE: 'prep_referal_url_copied'
    },
    prep_referal_reward: {
        GA: 'referal_reward',
        WE: 'prep_referal_reward'
    },
    prep_plus_referral_reward_click: {
        GA: 'prepplus_referral_reward_click',
        WE: 'prep_plus_referral_reward_click'
    },
    prep_plus_referral_reward_purchase: {
        GA: 'prepplus_referral_reward_purchase',
        WE: 'prep_plus_referral_reward_purchase'
    },
    prep_referral_nudge_clicked: {
        GA: 'referral_nudge_clicked',
        WE: 'prep_referral_nudge_clicked'
    },
    prep_practice_mode_switched: {
        GA: 'practice_mode_switched',
        WE: 'prep_practice_mode_switched'
    },
    prep_learning_mode_switched: {
        GA: 'learning_mode_switched',
        WE: 'prep_learning_mode_switched'
    },
    video_played: {
        GA: 'video_played',
        WE: 'prep_video_played'
    },
    ondemand_video_played: {
        GA: 'ondemand_video_played',
        WE: 'prep_ondemand_video_played'
    },
    pricing_signup_begin: {
        GA: 'pricing_signup_begin',
        WE: 'prep_pricing_signup_begin'
    },
    pricing_events_click: {
        GA: 'pricing_events_click',
        WE: 'prep_pricing_events_click'
    },
    referral_clicked: {
        GA: 'referral_clicked',
        WE: 'prep_referral_clicked'
    },
    referal_url_copied: {
        GA: 'referal_url_copied',
        WE: 'prep_referral_url_copied'
    },
    plans_call_booked: {
        GA: 'call_booked',
        WE: 'prep_call_booked'
    },
    home_secondary_signup_begin: {
        GA: 'home_secondary_signup_begin'
    },
    home_banner_click: {
        WE: 'home_banner_click'
    },
    dashboard_banner_click: {
        WE: 'dashboard_banner_click'
    },
    pricing_banner_click: {
        WE: 'pricing_banner_click'
    },
    liveclass_banner_click: {
        WE: 'liveclass_banner_click'
    },
    ondemand_banner_click: {
        WE: 'ondemand_banner_click'
    },
    gmat_live_classes_clicked: {
        GA: 'gmat_live_classes_clicked',
        WE: 'prep_gmat_live_classes_clicked'
    },
    prep_onlypractice_selected: {
        WE: 'prep_onlypractice_selected',
        GA: 'practice_selected'
    },
    prep_completeprep_selected: {
        WE: 'prep_completeprep_selected',
        GA: 'completeprep_selected'
    },
    prep_classes_learnmore_clicked: {
        WE: 'prep_classes_learnmore_clicked',
        GA: 'classes_learnmore_clicked'
    },
    prep_plus_continue_1m: {
        WE: 'prep_plus_continue_1m',
        GA: 'prep_plus_continue_1m'
    },
    prep_plus_switchedto_3m: {
        WE: 'prep_plus_switchedto_3m',
        GA: 'prep_plus_switchedto_3m'
    },
    checkout_discount_accepted: {
        WE: 'prep_checkout_discount_accepted',
        GA: 'checkout_discount_accepted'
    },
    checkout_discount_rejected: {
        WE: 'prep_checkout_discount_rejected',
        GA: 'checkout_discount_rejected'
    },

    trial_started: {
        GA: '3_day_trial_started',
        WE: '3_day_trial_started'
    },
    nav_learning_switched: {
        GA: 'nav_learning_switched',
        WE: 'prep_nav_learning_switched'
    },
    nav_practice_switched: {
        GA: 'nav_practice_switched',
        WE: 'prep_nav_practice_switched'
    },
    guide_clicked: {
        GA: 'guide_clicked',
        WE: 'prep_guide_clicked'
    },
    blog_clicked: {
        GA: 'blog_clicked',
        WE: 'prep_blog_clicked'
    },
    guide_page_opened: {
        GA: 'guide_page_opened',
        WE: 'prep_guide_page_opened'
    },
    guide_tab_clicked: {
        GA: 'guide_tab_clicked',
        WE: 'prep_guide_tab_clicked'
    },
    guide_hook_clicked: {
        GA: 'guide_hook_clicked',
        WE: 'prep_guide_hook_clicked'
    },
    blog_listing_page_opened: {
        GA: 'blog_listing_page_opened',
        WE: 'prep_blog_listing_page_opened'
    },
    blog_card_clicked: {
        GA: 'blog_card_clicked ',
        WE: 'prep_blog_card_clicked '
    },
    blog_opened: {
        GA: 'blog_opened ',
        WE: 'prep_blog_opened '
    },
    table_of_content_clicked: {
        GA: 'table_of_content_clicked',
        WE: 'prep_table_of_content_clicked'
    },
    related_discussion_clicked: {
        GA: 'related_discussion_clicked',
        WE: 'prep_related_discussion_clicked'
    },
    footer_element_clicked: {
        GA: 'footer_element_clicked',
        WE: 'prep_footer_element_clicked'
    },
    prep_classes_nav_click: {
        GA: 'classes_nav_click',
        WE: 'prep_classes_nav_click'
    },
    prep_classes_details_click: {
        GA: 'classes_details_click',
        WE: 'prep_classes_details_click'
    },
    upgrade_classes_clicked: {
        GA: 'upgrade_classes_clicked',
        WE: 'prep_upgrade_classes_clicked'
    },
    upgrade_classes_cta: {
        GA: 'upgrade_classes_cta',
        WE: 'prep_upgrade_classes_cta'
    },
    upgraded_classes: {
        GA: 'upgraded_classes',
        WE: 'prep_upgraded_classes'
    },

    // Ondemand
    prep_ondemand_nav_click: {
        GA: 'ondemand_nav_click',
        WE: 'prep_ondemand_nav_click'
    },
    prep_ondemand_LP_register: {
        GA: 'ondemand_LP_register',
        WE: 'prep_ondemand_LP_register'
    },
    prep_ondemand_LP_payment_proceed: {
        GA: 'ondemand_LP_payment_proceed',
        WE: 'prep_ondemand_LP_payment_proceed'
    },

    // vocab-builder
    vocab_tour_started: {
        GA: 'vocab_tour_started',
        WE: 'prep_vocab_tour_started'
    },
    vocab_tour_skipped: {
        GA: 'vocab_tour_skipped',
        WE: 'prep_vocab_tour_skipped'
    },
    vocab_tour_completed: {
        GA: 'vocab_tour_completed',
        WE: 'prep_vocab_tour_completed'
    },
    vocab_practice_started_Dn: {
        GA: 'vocab_practice_started',
        WE: 'prep_vocab_practice_started'
    },
    vocab_practice_completed_Dn: {
        GA: 'vocab_practice_completed',
        WE: 'prep_vocab_practice_completed'
    },
    vocab_upgrade: {
        GA: 'vocab_upgrade',
        WE: 'prep_vocab_upgrade'
    },
    prep_trustpilot_clicked: {
        WE: 'prep_trustpilot_clicked'
    },
    prep_upgrade_AIGS_solutions: {
        WE: 'prep_upgrade_AIGS_solutions'
    },

    prep_consultation_navbar: {
        GA: 'consultation_navbar',
        WE: 'prep_consultation_navbar'
    },
    on_demand_demo_click: {
        GA: 'on_demand_demo_click',
        WE: 'prep_on_demand_demo_click'
    },
    prep_live_demo_navbar: {
        GA: 'live_demo_joined'
    },

    // lead magnet
    signup_magnet_click: {
        GA: 'signup_magnet_click',
        WE: 'prep_signup_magnet_click'
    },
    signup_magnet_success: {
        GA: 'signup_magnet_success',
        We: 'prep_signup_magnet_success'
    },
    cheatsheet_download_click: {
        GA: 'cheatsheet_download_click ',
        WE: 'prep_cheatsheet_download_click '
    },
    magnet_video_click: {
        GA: 'magnet_video_click',
        WE: 'prep_magnet_video_click'
    },

    // upselling
    practice3m_switchedto_ondemand: {
        GA: 'practice3m_switchedto_ondemand',
        WE: 'prep_practice3m_switchedto_ondemand'
    },
    continuewith_practice3m: {
        GA: 'prep_continuewith_practice3m',
        WE: 'prep_continuewith_practice3m'
    },
    practice1m_switchedto_ondemand: {
        GA: 'practice1m_switchedto_ondemand',
        WE: 'prep_practice1m_switchedto_ondemand'
    },
    continuewith_practice1m: {
        GA: 'prep_continuewith_practice1m',
        WE: 'prep_continuewith_practice1m'
    },

    // Trustpilot reviews
    prep_morereviews_lp: {
        GA: 'prep_morereviews_lp',
        WE: 'prep_morereviews_lp'
    },
    prep_morereviews_pricing: {
        GA: 'prep_morereviews_pricing',
        WE: 'prep_morereviews_pricing'
    },
    prep_morereviews_liveclasseslp: {
        GA: 'prep_morereviews_liveclasseslp',
        WE: 'prep_morereviews_liveclasseslp'
    },
    prep_morereviews_ondemandlp: {
        GA: 'prep_morereviews_ondemandlp',
        WE: 'prep_morereviews_ondemandlp'
    },

    // Help me choose plan
    prep_planselector_clicked: {
        GA: 'prep_planselector_clicked',
        WE: 'prep_planselector_clicked'
    },

    // Trial expiry upgrade nudges
    upgrade_to_practice: {
        GA: 'upgrade_to_practice',
        WE: 'prep_upgrade_to_practice'
    },
    upgrade_to_ondemand: {
        GA: 'upgrade_to_ondemand',
        WE: 'prep_upgrade_to_ondemand'
    },
    upgrade_to_liveclasses: {
        GA: 'upgrade_to_liveclasses',
        WE: 'prep_upgrade_to_liveclasses'
    },
    download_app_click: {
        GA: 'download_app_click',
        WE: 'prep_download_app_click'
    },
    // Auth and onboarding events
    legacy_otp_sent: {
        GA: 'legacy_otp_sent',
        WE: 'prep_legacy_otp_sent'
    },
    legacy_otp_verified: {
        GA: 'legacy_otp_verified',
        WE: 'prep_legacy_otp_verified'
    },
    first_name: {
        GA: 'first_name',
        WE: 'prep_first_name'
    },
    last_name: {
        GA: 'last_name',
        WE: 'prep_last_name'
    },
    onboarding_email: {
        GA: 'onboarding_email',
        WE: 'prep_onboarding_email'
    },
    onboarding_mobile_number: {
        GA: 'onboarding_mobile_number',
        WE: 'prep_onboarding_mobile_number'
    },
    onboarding_exam_type: {
        GA: 'onboarding_exam_type',
        WE: 'prep_onboarding_exam_type'
    },
    onboarding_english_exam_type: {
        GA: 'onboarding_english_exam_type',
        WE: 'onboarding_english_exam_type'
    },
    onboarding_intake_year: {
        GA: 'onboarding_intake_year',
        WE: 'prep_onboarding_intake_year'
    },
    onboarding_role: {
        GA: 'onboarding_role',
        WE: 'prep_onboarding_role'
    },
    onboarding_attempt_stage: {
        GA: 'onboarding_attempt_stage',
        WE: 'prep_onboarding_attempt_stage'
    },
    onboarding_exam_registration: {
        GA: 'onboarding_exam_registration',
        WE: 'prep_onboarding_exam_registration'
    },
    onboarding_tentative_date: {
        GA: 'onboarding_tentative_date',
        WE: 'prep_onboarding_tentative_date'
    },
    onboarding_exam_date: {
        GA: 'onboarding_exam_date',
        WE: 'prep_onboarding_exam_date'
    },
    create_account: {
        GA: 'create_account',
        WE: 'prep_create_account'
    },
    user_detail_modal_shown: {
        GA: 'user_detail_modal_shown',
        WE: 'prep_user_detail_modal_shown'
    },
    // Other events
    home_click: {
        GA: 'home_click',
        WE: 'prep_home_click'
    },
    enquire_now: {
        GA: 'enquire_now',
        WE: 'prep_enquire_now'
    },
    pricing: {
        GA: 'pricing',
        WE: 'prep_pricing'
    },
    login_click: {
        GA: 'login_click',
        WE: 'prep_login_click'
    },
    signup_click: {
        GA: 'signup_click',
        WE: 'prep_signup_click'
    },

    start_free_trial: {
        GA: 'start_free_trial',
        WE: 'prep_start_free_trial'
    },
    gre_diagnostic_test: {
        GA: 'gre_diagnostic_test',
        WE: 'prep_gre_diagnostic_test'
    },
    start_gre_test: {
        GA: 'start_gre_test',
        WE: 'prep_start_gre_test'
    },
    study_planner_click: {
        GA: 'study_planner_click',
        WE: 'prep_study_planner_click'
    },
    vocab_builder: {
        GA: 'vocab_builder',
        WE: 'prep_vocab_builder'
    },
    study_planner_setup_click: {
        GA: 'study_planner_setup_click',
        WE: 'prep_study_planner_setup_click'
    },
    signup_modal_shown: {
        GA: 'signup_modal_shown',
        WE: 'prep_signup_modal_shown'
    },
    signup_modal: {
        GA: 'signup_modal',
        WE: 'prep_signup_modal'
    },
    vocab_builder_start: {
        GA: 'vocab_builder_start',
        WE: 'prep_vocab_builder_start'
    },
    book_demo: {
        GA: 'book_demo',
        WE: 'prep_book_demo'
    },
    register_now: {
        GA: 'register_now',
        WE: 'prep_register_now'
    },
    live_course_enroll_now: {
        GA: 'live_course_enroll_now',
        WE: 'prep_live_course_enroll_now'
    },
    enroll_now: {
        GA: 'enroll_now',
        WE: 'prep_enroll_now'
    },
    redirection_modal: {
        GA: 'redirection_modal',
        WE: 'prep_redirection_modal'
    },
    google_auth_popup_skipped: {
        GA: 'google_auth_popup_skipped',
        WE: 'prep_google_auth_popup_skipped'
    },
    google_auth_popup_dismissed: {
        GA: 'google_auth_popup_dismissed',
        WE: 'prep_google_auth_popup_dismissed'
    },
    google_auth_popup_shown: {
        GA: 'google_auth_popup_shown',
        WE: 'prep_google_auth_popup_shown'
    },
    google_auth_signup: {
        GA: 'google_auth_signup',
        WE: 'prep_google_auth_signup'
    },
    gauth_verify_otp: {
        GA: 'gauth_verify_otp',
        WE: 'prep_gauth_verify_otp'
    },
    get_prep_practice: {
        GA: 'get_prep_practice',
        WE: 'prep_get_prep_practice'
    },
    get_prep_on_demand: {
        GA: 'get_prep_on_demand',
        WE: 'prep_get_prep_on_demand'
    },
    get_prep_live_classes: {
        GA: 'get_prep_live_classes',
        WE: 'prep_get_prep_live_classes'
    },
    yocket_redirection: {
        GA: 'yocket_redirection',
        WE: 'prep_yocket_redirection'
    },
    // chat events
    chatbot_click: {
        GA: 'chatbot_click',
        WE: 'prep_chatbot_click'
    },
    chatbot_popup_onclick: {
        GA: 'chatbot_popup_onclick',
        WE: 'prep_chatbot_popup_onclick'
    },
    chatbot_full_name: {
        GA: 'chatbot_full_name',
        WE: 'prep_chatbot_full_name'
    },
    chatbot_mobile_number: {
        GA: 'chatbot_mobile_number',
        WE: 'prep_chatbot_mobile_number'
    },
    chatbot_intake: {
        GA: 'chatbot_intake',
        WE: 'prep_chatbot_intake'
    },
    chatbot_submit: {
        GA: 'chatbot_submit',
        WE: 'prep_chatbot_submit'
    },
    chatbot_dismiss: {
        GA: 'chatbot_dismiss',
        WE: 'prep_chatbot_dismiss'
    },
    chatbot_automatic: {
        GA: 'chatbot_automatic',
        WE: 'prep_chatbot_automatic'
    },
    // misc
    signup_type: {
        navbar: 'navbar_signup',
        qd_report: 'quick_diag_report_signup',
        priority_planner: 'priority_planner_signup',
        vocab_connect: 'vocab_connect',
        home: 'home_page'
    },
    view_report_cta: {
        GA: 'view_report_cta',
        WE: 'prep_view_report_cta'
    },
    redirection_modal_shown: {
        GA: 'redirection_modal_shown',
        WE: 'prep_redirection_modal_shown'
    },
    calculator_clicked: {
        GA: 'calculator_clicked',
        WE: 'prep_calculator_clicked'
    },
    gre_gmat_convert: {
        GA: 'gre_gmat_convert',
        WE: 'prep_gre_gmat_convert'
    },
    gre_score_convert: {
        GA: 'gre_score_convert',
        WE: 'prep_gre_score_convert'
    },
    gmat_score_convert: {
        GA: 'gmat_score_convert',
        WE: 'prep_gmat_score_convert'
    },

    // Open Form Events

    exam_type_clicked: {
        GA: 'exam_type_clicked',
        WE: 'prep_exam_type_clicked'
    },
    english_exam_type_clicked: {
        GA: 'english_exam_type_clicked',
        WE: 'prep_english_exam_type_clicked'
    },
    role_clicked: {
        GA: 'role_clicked',
        WE: 'prep_role_clicked'
    },
    intake_year_clicked: {
        GA: 'intake_year_clicked',
        WE: 'prep_intake_year_clicked'
    },
    continue_cta_step_1: {
        GA: 'continue_cta_step_1',
        WE: 'prep_continue_cta_step_1'
    },
    full_name_clicked: {
        GA: 'full_name_clicked',
        WE: 'prep_full_name_clicked'
    },
    email_clicked: {
        GA: 'email_clicked',
        WE: 'prep_email_clicked'
    },
    mobile_number_clicked: {
        GA: 'mobile_number_clicked',
        WE: 'prep_mobile_number_clicked'
    },
    otp_sent: {
        GA: 'otp_sent',
        WE: 'prep_otp_sent'
    },
    back_step_2: {
        GA: 'back_step_2',
        WE: 'prep_back_step_2'
    },
    back_step_3: {
        GA: 'back_step_3',
        WE: 'prep_back_step_3'
    },
    otp_verified: {
        GA: 'otp_verified',
        WE: 'prep_otp_verified'
    },
    mock_test_page_clicked: {
        GA: 'mock_test_page_clicked',
        WE: 'prep_mock_test_page_clicked'
    },
    gre_hero_cta: {
        GA: 'gre_hero_cta',
        WE: 'prep_gre_hero_cta'
    },
    question_paper_clicked: {
        GA: 'question_paper_clicked',
        WE: 'prep_question_paper_clicked'
    },
    sample_paper_signup_modal: {
        GA: 'sample_paper_signup_modal',
        WE: 'prep_sample_paper_signup_modal'
    },
    sample_paper: {
        GA: 'sample_paper',
        WE: 'prep_sample_paper'
    },
    signup_cta: {
        GA: 'signup_cta',
        WE: 'prep_signup_cta'
    },
    view_plans: {
        GA: 'view_plans',
        WE: 'prep_view_plans'
    },
    free_resource_clicked: {
        GA: 'free_resource_clicked',
        WE: 'prep_free_resource_clicked'
    },

    // OTP Verification events
    prepplus_3m_otp_verified: {
        GA: 'prepplus_3m_otp_verified',
        WE: 'prepplus_3m_otp_verified'
    },
    prepplus_1m_otp_verified: {
        GA: 'prepplus_1m_otp_verified',
        WE: 'prepplus_1m_otp_verified'
    },
    prepplus_ondemand_otp_verified: {
        GA: 'prepplus_ondemand_otp_verified',
        WE: 'prepplus_ondemand_otp_verified'
    },
    prepplus_6m_otp_verified: {
        GA: 'prepplus_6m_otp_verified',
        WE: 'prepplus_6m_otp_verified'
    },

    // Continue Payment events
    prepplus_3m_continue_payment: {
        GA: 'prepplus_3m_continue_payment',
        WE: 'prepplus_3m_continue_payment'
    },
    prepplus_1m_continue_payment: {
        GA: 'prepplus_1m_continue_payment',
        WE: 'prepplus_1m_continue_payment'
    },
    prepplus_ondemand_continue_payment: {
        GA: 'prepplus_ondemand_continue_payment',
        WE: 'prepplus_ondemand_continue_payment'
    },
    prepplus_6m_continue_payment: {
        GA: 'prepplus_6m_continue_payment',
        WE: 'prepplus_6m_continue_payment'
    }
};

export function isValidSignupType(signupType) {
    if (!signupType) return false;

    const validSignupTypes = Object.values(analyticEvents.signup_type);

    if (signupType in validSignupTypes) return true;
    else return false;
}

export const ANALYTIC_SOURCE_MODULES = Object.freeze({
    NAVBAR: 'navbar',
    MOBILE_NAVBAR: 'mobile_navbar',
    TABLET_NAVBAR: 'tablet_navbar',
    MOBILE_SIDEBAR: 'mobile_sidebar',
    TABLET_SIDEBAR: 'tablet_sidebar',
    HOMEPAGE: 'homepage',
    STUDY_PLANNER: 'study_planner',
    VOCAB_BUILDER: 'vocab_builder',
    LIVE_COURSE: 'live_course',
    ON_DEMAND_COURSE: 'on_demand_course',
    PRICING: 'pricing',
    REDIRECTION_MODAL: 'redirection_modal',
    LOGIN_PAGE: 'login_page',
    PRICING_PAGE_MODAL: 'pricing_page_modal',
    YOCKET_ONBOARDED: 'yocket_onboarded',
    HOMEPAGE_LABEL: 'homepage_label',
    PRICING_PAGE_LABEL: 'pricing_page_label',
    GRE_DIAGNOSTIC_TEST_REPORT: 'gre_diagnostic_test_report',
    BLOGS_GUIDES: 'blogs_guides',
    OPEN_CONTACT_FORM: 'open_contact_form',
    DOWNLOADABLE_RESOURCE: 'downloadable_resource',
    MOCK_TEST_PAGE: 'mock_test_page'
});
export const ROUTE_TO_SOURCE_MODULE_MAP = {
    [ROUTES.ON_DEMAND]: ANALYTIC_SOURCE_MODULES.ON_DEMAND_COURSE,
    [ROUTES.ON_DEMAND_V2]: ANALYTIC_SOURCE_MODULES.ON_DEMAND_COURSE,
    [ROUTES.CLASSES_LP]: ANALYTIC_SOURCE_MODULES.LIVE_COURSE,
    [ROUTES.GRE_MOCK_TEST]: ANALYTIC_SOURCE_MODULES.MOCK_TEST_PAGE,
    [ROUTES.PRICING]: ANALYTIC_SOURCE_MODULES.PRICING
};
export const AUTH_FLOW_TYPE = Object.freeze({
    LEGACY: 'legacy',
    GAUTH: 'gauth'
});

export default analyticEvents;
